import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useMsal } from '@azure/msal-react';
import { TokenHelper } from '../../TokenHelper';
import { ConsultantDocument } from '../../interfaces/Consultant';
import { TeamsState } from '../../store/TeamsState';
import { useEditorStyles } from '../Styles/Editor';
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Field, Label, Link, Switch, SwitchOnChangeData, Toast, ToastTitle, ToastTrigger, useToastController } from '@fluentui/react-components';
import { ConsultantActionCreators } from '../../store/consultants';
import { useTranslation } from 'react-i18next';

export const ConsultantDocumentDeleteConfirm = () => {
    // All data needed for edition should be loaded before calling the editor
    const consultantDocument = useSelector<ApplicationState, ConsultantDocument | null>((state: ApplicationState) => state.consultantsState.consultantDocumentDelete);
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    // Gen hooks
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const styles = useEditorStyles();
    const { dispatchToast, updateToast } = useToastController("NeoToasterUnique");
    const { t } = useTranslation();
    // Form validation
    const [confirmDelete, setConfirmDelete] = React.useState(false);

    if (consultantDocument === null) {
        return <></>;
    }

    const submit = () => {
        TokenHelper.GetToken(instance, teamsState)
            .then(token => {
                if (token !== null) {
                    const toastId = (Math.random() + 1).toString(36).substring(7);
                    dispatchToast(
                        <Toast appearance="inverted">
                            <ToastTitle>
                                Deleting Document...
                            </ToastTitle>
                        </Toast>,
                        { intent: "info", timeout: -1, position: "top-end", toastId: toastId }
                    );
                    fetch("api/ConsultantsDocuments/" + (consultantDocument && consultantDocument.consultantdocumentid !== null ? consultantDocument.consultantdocumentid : ""), {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: "bearer " + token,
                        },
                        mode: "cors",
                        cache: "default",
                    })
                        .then(response => {
                            if (response.status === 200) {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>Dismiss</Link>
                                                </ToastTrigger>
                                            }>
                                                Document deleted
                                            </ToastTitle>
                                        </Toast>
                                    ),
                                    intent: "success",
                                    toastId,
                                    timeout: 5000,
                                });
                                if (consultantDocument) dispatch(ConsultantActionCreators.patchConsultantDocumentDeletionEdition(consultantDocument));
                                dispatch(ConsultantActionCreators.requestConsultantDocumentdeletion(null));
                            }
                            else {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>Dismiss</Link>
                                                </ToastTrigger>
                                            }>
                                                Document delete failed
                                            </ToastTitle>
                                        </Toast>
                                    ),
                                    intent: "error",
                                    toastId,
                                    timeout: 10000,
                                });
                            }
                        });
                }
            });
    };

    return <Dialog
        open
        modalType="modal">
        <DialogSurface>
            <DialogBody>
                <DialogTitle>Delete timesheet</DialogTitle>
                <DialogContent>
                    <form
                        onSubmit={() => {
                            dispatch(ConsultantActionCreators.requestConsultantDocumentdeletion(null));
                        }}
                        autoComplete="off"
                    >
                        <Field label="Date">
                            <Label className={styles.label}>{consultantDocument.documentDate ? new Date(consultantDocument.documentDate).toLocaleDateString() : "-"}</Label>
                        </Field>
                        <Field label="Source">
                            <Label className={styles.label}>{consultantDocument.documentSource !== null ? consultantDocument.documentSource : ""}</Label>
                        </Field>
                        <Field label="Amount">
                            <Label className={styles.label}>{consultantDocument.documentAmount ? consultantDocument.documentAmount.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) : "-"}</Label>
                        </Field>
                        <Field label="Description">
                            <Label className={styles.label}>{consultantDocument.description !== null ? consultantDocument.description : ""}</Label>
                        </Field>
                        <Switch checked={confirmDelete} label="Confirm deletion" onChange={(ev: React.ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => { setConfirmDelete(data.checked); }} />
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => dispatch(ConsultantActionCreators.requestConsultantDocumentdeletion(null))}
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        onClick={() => submit()}
                        type="submit"
                        form="my-form-id"
                        appearance="primary"
                        disabled={!confirmDelete}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>;
};